<template>
  <el-dialog
    :title="'编辑用户'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名" prop="username">
        <div v-html="ruleForm.username"></div>
      </el-form-item>
      <el-form-item label="是否禁用" prop="disabled">
        <el-checkbox
          v-model.trim="ruleForm.disabled"
          type="disabled"
        ></el-checkbox>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="setDisable()">确定</el-button>
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: ["userInfo2"],
  data() {
    return {
      ruleForm: {
        username: this.userInfo2 ? this.userInfo2.username : "",
        disabled: this.userInfo2 ? this.userInfo2.disabled : ""
      }
    };
  },
  methods: {
    setDisable() {
      let requestModel = {
        userNames: [this.ruleForm.username],
        disabled: this.ruleForm.disabled
      };

      this.$axios(this.$urlMapping["禁止用户"], {
        data: requestModel
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        this.$emit("onSearch");
        this.$emit("closeForm");
      });
      return false;
    },
    closeForm() {
      this.$emit("closeForm");
    }
  }
};
</script>

<style lang="less" scoped></style>
